import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IDatasets } from '../../interfaces/i-datasets';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dataset-selection',
  templateUrl: './dataset-selection.component.html',
  styleUrl: './dataset-selection.component.scss',
})
export class DatasetSelectionComponent implements OnInit {
  public datasets: IDatasets[] = [];
  public error: HttpErrorResponse | undefined;

  constructor(
    private api: ApiService,
    private router: Router,
    public spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.loadGRCh38Datasets();
  }

  loadGRCh38Datasets(): void {
    this.spinner.show();
    this.api.getGRCh38Datasets().subscribe({
      next: (result) => {
        this.datasets = result;
        this.spinner.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.spinner.hide();
        // If error, redirect to homepage
        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 3000);
      },
    });
  }

  selectDataset(datasetName: string): void {
    this.router.navigate(['/gwas-16/display', datasetName]);
  }

  goBack(): void {
    this.router.navigate(['/home']);
  }
}
